import { PropsWithChildren, createContext, useState } from "react";

export type ExplanationSidebarState = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  selectedClauseId: string;
  setSelectedClauseId: (id: string) => void;
};

export const ExplanationSidebarContext = createContext<ExplanationSidebarState>(
  {} as ExplanationSidebarState
);

export const ExplanationSidebarProvider = ({ children }: PropsWithChildren) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [selectedClauseId, setSelectedClauseId] = useState<string>("");

  return (
    <ExplanationSidebarContext.Provider
      value={{
        isOpen,
        setIsOpen,
        selectedClauseId,
        setSelectedClauseId,
      }}
    >
      {children}
    </ExplanationSidebarContext.Provider>
  );
};
